import { Card, Row, Col, Tag } from 'antd';
import { FaUser, FaHistory } from 'react-icons/fa';
import dayjs from 'dayjs';
const ParticipantInfoStep = ({ participant, previousCalls }) => {
  return (
    <>
      <Card
        size="small"
        style={{ marginBottom: 20, borderLeft: '4px solid #1890ff' }}
        title={
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <FaUser style={{ color: '#1890ff' }} />
            <span>Información del Beneficiario</span>
          </div>
        }
      >
        <Row gutter={[16, 12]}>
          <Col span={12}>
            <strong>Nombre completo:</strong>
            <div style={{ color: '#666' }}>
              {participant.nombres} {participant.apellidos}
            </div>
          </Col>
          <Col span={12}>
            <strong>Documento:</strong>
            <div style={{ color: '#666' }}>
              {participant.tipo_documento_nombre} {participant.num_identificacion}
            </div>
          </Col>
          <Col span={12}>
            <strong>Teléfono:</strong>
            <div style={{ color: '#666' }}>{participant.telefono || 'No registrado'}</div>
          </Col>
          <Col span={12}>
            <strong>Correo:</strong>
            <div style={{ color: '#666' }}>{participant.correo || 'No registrado'}</div>
          </Col>
          <Col span={12}>
            <strong>Departamento:</strong>
            <div style={{ color: '#666' }}>{participant.departamento}</div>
          </Col>
          <Col span={12}>
            <strong>Municipio:</strong>
            <div style={{ color: '#666' }}>{participant.municipio}</div>
          </Col>
        </Row>
      </Card>

      {previousCalls?.length > 0 && (
        <Card
          size="small"
          style={{ marginBottom: 20, borderLeft: '4px solid #52c41a' }}
          title={
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <FaHistory style={{ color: '#52c41a' }} />
              <span>Historial de Llamadas</span>
            </div>
          }
        >
          {previousCalls.map((call, index) => (
            <div
              key={index}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: 8,
                padding: '8px 12px',
                backgroundColor: '#fafafa',
                borderRadius: 6
              }}
            >
              <div>
                <strong>Llamada número: {call.numeroIntento}</strong>
                <div style={{ fontSize: '12px', color: '#666' }}>
                  {call.fechaContacto ? dayjs(call.fechaContacto).format('DD/MM/YYYY HH:mm') : 'Sin fecha'}
                </div>
              </div>
              <Tag color={
                call.estadoLlamadaId === 2 ? 'green' :
                  call.estadoLlamadaId === 3 ? 'red' :
                    call.estadoLlamadaId === 1 ? 'blue' :
                      'default'
              }>
                {call.estadoLlamadaNombre}
              </Tag>
            </div>
          ))}
        </Card>
      )}
    </>
  );
};

export default ParticipantInfoStep;